



































































import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import mixins from 'vue-typed-mixins';
import { mapGetters } from 'vuex';
import { MenuItem } from '@/route-mapping';
import { User, Location } from '@/Stores/UserStore';
import { supportedLocales } from '@/internationalization';
import Roles from '@/Shared/Roles';
import { stringCompare } from '@/Shared/Utilities';
import { authorizeInternalNavigation } from '@/router';

export default mixins(LocationBasedMixin).extend({
    async beforeMount() {
        const locations: Location[] = await this.$typedStore.modules.userModule.actions.getAllowedLocations();
        this.allowedLocations = locations;
        this.selectedLocation = locations.find(item => stringCompare(item.urlSegment, this.location)) || null;
        if (this.selectedLocation) {
            // This will also call 'getMenuItems'
            await this.$typedStore.actions.changeCurrentLocation(this.selectedLocation);
            const _ = this.$typedStore.modules.userModule.actions.getCurrentRoles();
        }
    },
    props: {
        location: {
            required: true,
            default: '',
            type: '' as any as () => string,
        }
    },
    data() {
        return {
            selectedLocation: null as Location | null,
            allowedLocations: [] as Location[],
            menuIcons: {
                // probably not how we'll get assets in other contexts, but since
                // we have this set with getting the menus out of the database
                // some calculation has to happen to pick the icon
                default: require('@/assets/appeals-icon.svg'),
                appeals: require('@/assets/appeals-icon.svg'),
                collections: require('@/assets/collections-icon.svg'),
                overview: require('@/assets/overview-icon.svg'),
                processing: require('@/assets/processing-icon.svg'),
                ticketing: require('@/assets/ticketing-icon.svg'),
            } as { [key: string]: string }
        };
    },
    computed: {
        activeLocations(): Location[] {
            return this.allowedLocations.sort((a, b) => a.companyName.localeCompare(b.companyName));
        },
        ...mapGetters({
            menuItems: 'menuItems'
        }),
        visibleMenuItems(): MenuItem[] {
            const roles = this.$typedStore.modules.userModule.getters.currentRoles;
            if (!this.selectedLocation || !roles) {
                return [];
            }
            const currentLocation = this.selectedLocation.urlSegment;

            const reduce = (newArray: MenuItem[], item: MenuItem) => {
                if (stringCompare(item.text, 'ADMIN')
                    && !roles[Roles.SystemAdmin]
                    && !roles[Roles.CompanyAdmin]) {
                    return newArray;
                }

                if (stringCompare(item.text, 'MISSING RO REPORT')
                    && (roles[Roles.MobileEnforcer]
                        || roles[Roles.EnforcerSupervisor]
                        || roles[Roles.HearingOfficer])) {
                    return newArray;
                }

                if (stringCompare(item.text, 'FINANCIAL INTERFACE')
                    && !stringCompare(currentLocation, 'CityOfMedford')) {
                    return newArray;
                }

                if (stringCompare(item.text, 'AGING DETAIL REPORT')
                    && !stringCompare(currentLocation, 'Hartford')) {
                    return newArray;
                }

                if (stringCompare(item.text, 'DIAGNOSTICS')
                    && !roles[Roles.SystemAdmin]
                    && !roles[Roles.CompanyAdmin]) {
                    return newArray;
                }

                if ((stringCompare(item.text, 'DAILY RING DETAIL REPORT')
                    || stringCompare(item.text, 'DAILY RING SUMMARY REPORT'))
                    && !stringCompare(currentLocation, 'CityOfLincoln')
                    && !stringCompare(currentLocation, 'Demo')) {
                    return newArray;
                }

                if (stringCompare(item.text, 'REVENUE BY GROUP SUMMARY')
                    && !stringCompare(currentLocation, 'MassBayTransAuth')
                    && !stringCompare(currentLocation, 'Demo')) {
                    return newArray;
                }

                if (stringCompare(item.text, 'IN-ZONE vs OUT-ZONE REVENUE REPORT')
                    && !stringCompare(currentLocation, 'CityOfLawrence')
                    && !stringCompare(currentLocation, 'Demo')) {
                    return newArray;
                }

                if (stringCompare(item.text, 'LPR UNIT ACTIVITY REPORT')
                    && !stringCompare(currentLocation, 'MassBayTransAuth')
                    && !stringCompare(currentLocation, 'Demo')) {
                    return newArray;
                }

                item = Object.assign({}, item);
                if (item.children && item.children.length) {
                    item.children = item.children.reduce(reduce, []);
                }

                newArray.push(item);
                return newArray;

            };

            return (this.menuItems as MenuItem[]).reduce(reduce, []);
        }
    },
    methods: {
        hasChildren(item: MenuItem) {
            return item && item.children && item.children.length && item.children.length > 0;
        },
        isVueLink(menuItem: MenuItem) {
            return typeof menuItem.navigateUrl !== 'string' || menuItem.navigateUrl.indexOf('.aspx') === -1;
        },
        locationChanged(newLocation: string) {
            this.selectedLocation = this.allowedLocations
                .find(item => stringCompare(item.urlSegment, this.location))
                || null;
            this.locationSelected();
        },
        locationSelected() {
            if (this.selectedLocation) {
                this.$typedStore.actions.changeCurrentLocation(this.selectedLocation);
            }
        },
        translateMenuItem(menuItem: MenuItem) {
            const textPath = `locationRoot.menus.${menuItem.text}`;

            let text = '';

            if (this.$te(textPath)) {
                text = this.$t(textPath).toString().toLocaleLowerCase();
            }
            else {
                text = menuItem.text.toLocaleLowerCase();
            }

            if (text.indexOf('/') >= 0) {
                const regex = /(\S)\/(\S)/g;
                text = text.replace(regex, '$1 / $2');
            }

            return text;
        },
        getIcon(menuItem: MenuItem) {
            const menuItemTitle = this.translateMenuItem(menuItem);

            let iconUrl = this.menuIcons[menuItemTitle];

            if (!iconUrl) {
                iconUrl = this.menuIcons.default;
            }

            return iconUrl;
        }
    }
});
